export default "__VITE_ASSET__d6764b1b__"